import { ReactNode } from "react";

import CardWrapper from "./components/Wrapper";
import CardHeader from "./components/Header";
import CardContent from "./components/Content";
import { BoxProps } from "../Box";
import { TypographyProps } from "../Typography";

type CardProps = {
  children: ReactNode;
  fullbleed?: boolean;
  variant?: "secondary" | "primary";
  title?: ReactNode;
  titleTag?: TypographyProps["tag"];
  className?: string;
  headerSuffix?: ReactNode;
  titleSuffix?: ReactNode;
  headerPrefix?: ReactNode;
  contentGap?: BoxProps["gap"];
} & Pick<BoxProps, "fullHeight" | "fullWidth" | "margin" | "padding">;

const Card = ({
  children,
  fullbleed,
  variant,
  title,
  className,
  headerSuffix,
  titleSuffix,
  headerPrefix,
  titleTag,
  contentGap,
  ...restBoxProps
}: CardProps) => {
  return (
    <CardWrapper variant={variant} className={className} {...restBoxProps}>
      {title && (
        <CardHeader
          titleTag={titleTag}
          prefix={headerPrefix}
          titleSuffix={titleSuffix}
          suffix={headerSuffix}
        >
          {title}
        </CardHeader>
      )}
      <CardContent hasHeader={!!title} gap={contentGap} fullbleed={fullbleed}>
        {children}
      </CardContent>
    </CardWrapper>
  );
};

Card.displayName = "DS.Card";

export default Card;
